if( jQuery('.home').length > 0 ) {
	require('./maps');
}

/**
 * Breakpoints
*/
var viewport_3 = 320;
var viewport_4 = 480;
var viewport_7 = 768;
var viewport_9 = 992;
var viewport_10 = 1025;
var viewport_12 = 1200;
var viewport_13 = 1300;
var viewport_14 = 1400;
var viewport_16 = 1600;
var viewport_19 = 1920;

( function( $ ) {

	$( function() {

		$('.js-parallax').paroller();

		$('.js-hamburger').on('click', function(){
			$(this).toggleClass('is-active');
			$('.l-header__menu').toggleClass('is-active');
			$('body').toggleClass('is--menu');
		});

		$('.js-popup1').on('click', function(){
			$('.c-popup1').addClass('-active');
			setTimeout(function() {
				$('.c-popup1__close').addClass('-active');
			}, 50);
			$('body').addClass('is--popup');
		});
		$('.js-popup2').on('click', function(){
			$('.c-popup2').addClass('-active');
			setTimeout(function() {
				$('.c-popup2__close').addClass('-active');
			}, 50);
			$('body').addClass('is--popup');
		});

		$('.js-popup-close').on('click', function(){
			$('.c-popup, .c-popup__close').removeClass('-active');
			$('body').removeClass('is--popup');
		});

		setTimeout(function() {
			$('.c-slider.-vertical').addClass('bg').addClass('-black');
		}, 150);

		$('.js-banner-slider').slick({
			slidesToShow: 1,
			slidesToScroll: 1,
			vertical: true,
			arrows: false,
			dots: true,
			speed: 1000,
			autoplay: true,
			centerMode: false,
			infinite: true,
			responsive: [
				{
				breakpoint: 767,
					settings: {
						autoplaySpeed: 4000
					}
				}
			]
		});

		$('.js-logo-slider').slick({
			slidesToShow: 5,
			slidesToScroll: 1,
			arrows: false,
			dots: false,
			speed: 4000,
			autoplay: true,
			autoplaySpeed: 0,
			cssEase: 'linear',
			centerMode: false,
			infinite: true,
			responsive: [
				{
				breakpoint: 1024,
					settings: {
						slidesToShow: 3,
						slidesToScroll: 1
					}
				},
				{
				breakpoint: 767,
					settings: {
						slidesToShow: 2,
						slidesToScroll: 1
					}
				}
			]
		});

	} );

	// Sticky menu
	var make_sticky_from = 50;

	$(window).scroll(function () {

		var scroll = $(window).scrollTop();
		var sticky_header_height = $('.js-header').outerHeight();

		if (!$('body').hasClass('js-sticky')) {
			makeSticky(scroll, sticky_header_height);
		} else if ($('body').hasClass('js-sticky') && scroll == 0) {
			makeSticky(scroll, sticky_header_height);
		}

		scrollRotate();

	});

	function scrollRotate() {
		$('.js-rotate').each(function() {
			$(this).css('transform', 'rotate('+ (window.pageYOffset/10) + 'deg)');
		});
	}

	function scrollParallaxTop() {
		$(window).on('wheel', function(e) {
			if (e.originalEvent.deltaY > 0) {
				$('.l-content .c-belement__bottom').each(function() {
					var belement_bottom = $(this).css('bottom').slice(0, -2);
					$(this).css('bottom', parseFloat(belement_bottom) + (window.pageYOffset/150));
				});
			} else if (e.originalEvent.deltaY < 0) {
				$('.l-content .c-belement__top').each(function() {
					var belement_bottom = $(this).css('bottom').slice(0, -2);
					$(this).css('bottom', parseFloat(belement_bottom) - (window.pageYOffset/150));
				});
			}
		});
	}

	function scrollParallaxBottom() {
		$('.js-rotate').each(function() {
			$(this).css('transform', 'rotate('+ (window.pageYOffset/10) + 'deg)');
		});
	}

	function makeSticky(scroll, sticky_header_height) {
		if (scroll >= make_sticky_from) {
			$('body').addClass('is--sticky');
		}
		if (scroll <= make_sticky_from) {
			$('body').removeClass('is--sticky');
		}
	}


	function programmaAccordionTo(i){
		$(".programma-tab-title").removeClass("-active");
		$(".programma-tab-title:nth-child("+i+")").addClass("-active");
		$(".programma-tab-content").removeClass("-active");
		$(".programma-tab-content:nth-child("+i+")").addClass("-active");
	}

	$("body").on("click", ".programma-tab-title:not(.-active)", function(e){
		e.preventDefault();
		var prevAll = $(this).prevAll().length;
		programmaAccordionTo(prevAll+1);

	});

	$("body").on("click", ".c-video:not(.-playing)", function(){
        $(this).addClass("-playing");
        $(".video-poster", this).remove();
        if($(".youtube", this).length){
            var youtubeVideo = $(".youtube", this).attr("data-youtube");
            $(".youtube", this).append('<iframe width="100%" height="100%" autoplay="1" src="https://www.youtube.com/embed/'+youtubeVideo+'?autoplay=1" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>');
        }
        else{
            $("video", this).get(0).play();
        }

        //$("video", this).
    });
    $("body").on("click", ".c-video.-playing", function(){
        $(this).removeClass("-playing");
        $("video", this).get(0).pause();
        //$("video", this).
    });



} ) ( jQuery );
